<!-- Checkbox.vue -->
<template>
  <label
    class="checkmark_container"
    :class="[variant, disabled && 'disabled-input']"
  >
    <span
      class="t-white regular-s font-family-2"
      :class="[textClass === 'variant-2' && 'bold-xl']"
    >
      {{ label }}
    </span>
    <input
      type="checkbox"
      :checked="checked"
      @change="handleChange"
      ref="checkbox"
    />
    <span class="checkmark"></span>
  </label>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    variant: {
      type: String,
      default: "primary",
    },
    label: {
      type: String,
      default: "",
    },
    modelValue: {
      default: null,
    },
    selectableValue: {
      required: true,
    },
    isChecked: {
      default: true,
    },
    type: {
      default: "original",
    },
    emitFunction: {
      default: null,
    },
    emitFunctionKey: {
      default: "",
    },
    textClass: {
      default: "",
    },
    disabled: {
      default: false,
    },
  },

  methods: {
    handleChange(event) {
      if (this.emitFunction) {
        this.emitFunction(this.emitFunctionKey, this.selectableValue);
        return;
      }
      if (this.modelValue !== null && this.modelValue !== undefined) {
        if (event.target.checked) {
          let updatedValue = [...this.modelValue, this.selectableValue];
          this.$emit("update:modelValue", updatedValue);
        } else {
          let updatedValue = this.modelValue.filter(
            (modelV) => modelV !== this.selectableValue
          );
          this.$emit("update:modelValue", updatedValue);
        }
      }
    },
  },

  computed: {
    checked() {
      if (this.type === "original") {
        return this.modelValue?.includes(this.selectableValue) || false;
      }
      return this.isChecked;
    },
  },
};
</script>
